// src/modules/Courier/pages/Route/useRouteHandlers.js
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import api from "../../../services/api.js";
import { useRouteStore } from "./useRouteStore";

const useRouteHandlers = ({ routeId }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // из стора берём только экшены, которые нам нужны
  const {
    toggleGrouping,
    toggleExpandAll,
    setFilterStatus,
    setSearchQuery,
    setShowScanner,
    setReceiptModalOpen,
    setFailureModalReceiptId,
    setSelectedReceiptId,
    setSelectedReceipt,
  } = useRouteStore();

  /** 🔹 Вернуться к списку маршрутов */
  const handleGoBack = () => navigate("/courier/routes");

  /** 🔹 Открыть карту маршрута */
  const handleMap = () => navigate(`/courier/routes/${routeId}/map`);

  /** 🔹 Сортировка по адресу */
  const handleSortAddress = () => {
    // просто меняем порядок и рефетчим список через React Query
    queryClient.setQueryData(
      ['route', routeId],
      old => {
        if (!old) return old;
        const receipts = [...old.receipts].sort((a, b) =>
          a.delivery_address.localeCompare(b.delivery_address)
        );
        return { ...old, receipts };
      }
    );
  };

  /** 🔹 Поиск */
  const handleSearchSubmit = e => {
    e.preventDefault();
    document.activeElement.blur();
  };

  /** 🔹 Изменение статуса квитанции */
  const handleStatusChange = async (receiptId, status, reason = "") => {
    // проверка маркировки и сразу патчим
    const receipt = await api.get(`/receipts/${receiptId}`);
    const allScanned = receipt.products.every(
      p => !p.is_marked || p.marks.length >= p.actual_quantity
    );
    if (!allScanned && status === "Закрыта") {
      alert("Нельзя закрыть — не все марки отсканированы");
      return;
    }
    await api.patch(`/receipts/${receiptId}/status`, { status, reason });
    // рефетчим маршрут
    queryClient.invalidateQueries(['route', routeId]);
  };

  /** 🔹 Открыть детали квитанции */
  const openReceiptModal = receipt => {
    setSelectedReceipt(receipt);
    setReceiptModalOpen(true);
  };

  /** 🔹 Открыть сканер */
  const openScanner = receiptId => {
    setSelectedReceiptId(receiptId);
    setShowScanner(true);
  };

  /** 🔹 Пометить «не доставлено» (открыть форму) */
  const openFailureModal = receiptId => {
    setFailureModalReceiptId(receiptId);
  };

  return {
    handleGoBack,
    handleMap,
    handleSortAddress,
    handleSearchSubmit,
    toggleGrouping,
    toggleExpandAll,
    setFilterStatus,
    setSearchQuery,
    handleStatusChange,
    openReceiptModal,
    openScanner,
    openFailureModal,
  };
};

export default useRouteHandlers;
